<template>
    <div>
        <form enctype="multipart/form-data">
            <div class="form-group">
                <label>Name</label>
                <input
                    type="text"
                    class="form-control"
                    name="name"
                    :placeholder="__('general.brand_name')"
                    v-model="name"
                    @keyup.prevent="queueSearch"
                />
                <span class="form-text text-muted">
                    {{ __("product.brand_section.name") }}
                </span>
                <span class="form-text text-muted">
                    {{ __("product.brand_section.correct_spelling") }}
                </span>
                <span v-show="existing" class="form-text text-danger">
                    {{ __("product.brand_section.exists") }}
                </span>
            </div>

            <div class="form-group">
                <label>{{ __("general.brand_name") }} (optional)</label>
                <textarea
                    rows="2"
                    class="form-control"
                    :placeholder="__('general.description')"
                    v-model="description"
                />
                <span class="form-text text-muted">
                    {{ __("product.brand_section.description") }}
                </span>
            </div>

            <label>{{ __("general.logo") }} (optional)</label><br />
            <label for="logo" class="btn btn-primary mb-0 w-100">
                <span class="svg-icon svg-icon-md">
                    <i class="fas fa-file-image"></i>
                </span>
                {{ __("product.brand_section.choose_logo") }}
            </label>
            <input
                id="logo"
                type="file"
                @change="setLogo($event.target.files)"
                class="d-none"
            />
            <span class="form-text text-muted">
                {{ __("product.brand_section.logo") }}
            </span>
            <div v-if="logoImage" class="d-inline-block border border-light">
                <img
                    alt="logo"
                    :src="logoImage"
                    height="64"
                    class="mr-2 rounded overflow-hidden"
                />
            </div>
        </form>
        <button
            @click="createBrand"
            class="mt-4 btn btn-primary"
            :class="existing ? 'disabled' : ''"
            :disabled="existing"
        >
            <i class="fas fa-plus-square"></i
            >{{ __("product.brand_section.create") }}
        </button>
    </div>
</template>

<script>
export default {
    name: "CreateUserBrand",
    data() {
        return {
            name: "",
            existing: false,
            loading: false,
            description: "",
            logo: null,
            logoImage: null,
            waitingForSearch: false,
            lastKeyStroke: undefined,
        };
    },
    methods: {
        queueSearch() {
            //required to reduce API spam
            this.lastKeyStroke = new Date();

            if (!this.waitingForSearch) {
                this.waitingForSearch = true;
                setTimeout(this.checkForExistingBrand, 100);
            }
        },

        setLogo(files) {
            if (!files.length) return;
            this.logo = files[0];
            this.logoImage = URL.createObjectURL(files[0]);
        },

        async checkForExistingBrand() {
            let now = new Date();
            let secondsPassedSinceLastKeyStroke =
                now.getTime() - this.lastKeyStroke.getTime();
            if (secondsPassedSinceLastKeyStroke > 400) {
                this.waitingForSearch = false;
                this.existing = false;
                this.loading = true;
                let { data } = await axios.post(
                    this.$route("search-brand", {
                        name: this.name,
                        per_page: 1,
                    })
                );
                if (!_.isEmpty(data.data)) {
                    this.existing =
                        data.data[0].name.toLowerCase() ===
                        this.name.toLowerCase();
                }
                this.loading = false;
            } else {
                setTimeout(this.checkForExistingBrand, 100);
            }
        },

        async createBrand() {
            let formData = new FormData();
            formData.append("name", this.name);
            formData.append("description", this.description);
            formData.append("logo", this.logo);

            let { data } = await axios.post(
                this.$route("user_brands.create"),
                formData
            );
            this.$emit("selectBrand", data);
            toastr.success(__("product.toast_create_brand.success"));
        },
    },
};
</script>
